import { useCallback, useState } from 'react';
import { useDebounce } from 'react-use';

import { AxiosResponse } from 'axios';

const useFetch = (
  service:
    | Promise<AxiosResponse<any>>
    | (() => Promise<AxiosResponse<any>>)
    | undefined = undefined, // eslint-disable-line
  dependency: any[] | [undefined] = [] // eslint-disable-line
) => {
  const [isLoading, isLoadingSet] = useState<boolean>(true);
  const [data, dataSet] = useState<any>(); // eslint-disable-line

  const fetchData = useCallback(() => {
    if (!service) {
      isLoadingSet(false);
      return;
    }

    isLoadingSet(true);
    const request =
      typeof service === 'function'
        ? (service as () => Promise<AxiosResponse<any>>)()
        : (service as Promise<AxiosResponse<any>>);

    request
      .then((res) => {
        dataSet(res.data);
        isLoadingSet(false);
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
        isLoadingSet(false);
      });
  }, [service]);

  useDebounce(
    () => {
      fetchData();
    },
    350,
    dependency
  );

  return { isLoading, data, refetch: fetchData };
};

export { useFetch };
